import { Moon, Sun } from "lucide-react";
import RoundedIconButton from "@/shared/components/customButtons/roundedIconButton";
import { useThemeContext } from "@/shared/components/theme/ThemeContext";

const ThemeToggle = () => {
  const { theme, toggleTheme } = useThemeContext();
  return (
    <>
      {theme === "light"
        ? (
          <RoundedIconButton
            icon={Moon}
            onClick={toggleTheme}
            ariaLabel="Thème sombre"
          />
        )
        : (
          <RoundedIconButton
            icon={Sun}
            onClick={toggleTheme}
            ariaLabel="Thème clair"
          />
        )}
    </>
  );
};

export default ThemeToggle;
